import { Map as IMap, List as IList, Set as ISet } from 'immutable';
import { createSelector } from 'reselect';

import { history } from './routing';

import { getCurrencyCodes } from '../item/itemSelectors';



export const getFlowState = state => state.get('flow', IMap());


export const getFlowConfig = createSelector(
    getFlowState,
    flow => flow.get('flowConfig')
);


export const getBuyFlowConfig = createSelector(
    getFlowConfig,
    flowConfig => flowConfig.get('buy')
);


export const getPostBuyFlowConfig = createSelector(
    getFlowConfig,
    flowConfig => flowConfig.get('postBuy')
);


export const getStepConfigs = createSelector(
    getFlowState,
    flow => flow.get('stepConfigs')
);


export const getPreferredCurrencyCode = createSelector(
    getFlowState,
    getCurrencyCodes,
    (flow, currencyCodes) => (currencyCodes.isEmpty() ? flow.get('preferredCurrencyCode', null) : null)
);


export const getPreferredProgramCode = createSelector(
    getFlowState,
    flow => flow.get('preferredProgramCode', null)
);


export const getHomePath = createSelector(
    getBuyFlowConfig,
    flowConfig => flowConfig.first()
);


export const getPathStepConfig = (state, path) => state.getIn(['flow', 'stepConfigs', path]);


export const getLocationStepConfig = (state, location) => {
    const { pathname } = location; 
    const pathParts = new IList(pathname.split('/'))
        .shift() 
        .filter(part => part !== ''); 
    const found = getPathStepConfig(state, pathParts.last());
    return found || IMap();
};


export const getCurrentLocationStepConfig = (state) => {
    const currentLocation = history.location;
    return getLocationStepConfig(state, currentLocation);
};


export const getShowCartPaths = createSelector(
    getStepConfigs,
    stepConfigs => stepConfigs
        .filterNot(config => config.get('hideCartLink', false))
        .keySeq()
        .map(path => `*/${path}`)
        .toArray()
);


export const getDisplayBannerPaths = createSelector(
    getStepConfigs,
    stepConfigs => stepConfigs
        .filterNot(config => config.get('hidePromoBanner', false))
        .keySeq()
        .map(path => `*/${path}`)
        .toArray()
);

export const getFlowProgressState = state => state.get('flowProgress', IMap());

export const getFlowProgress = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('progress', ISet())
);
